import { types } from 'mobx-state-tree'
import { DictionaryModel } from '../common'

export const WorkCountryMarksModel = types.model('WorkCountryMarksModel', {
  id: types.number,
  countryId: types.number,
  work: types.maybeNull(DictionaryModel),
})
